// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pmleavepg-inline-1 {
  text-align: center;
  padding: 60px 20px;
}

.pmleavepg-inline-2 {
  margin: 0 auto 20px;
}

.pmleavepg-inline-3 {
  font-size: 14px;
  color: #64748b;
}

.pmleavepg-inline-4 {
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
}

.pmleavepg-inline-6 {
  padding: 0;
  overflow-x: auto;
}

.pmleavepg-inline-7 {
  text-align: center;
  padding: 40px;
  color: #94a3b8;
}

.pmleavepg-inline-8 {
  font-family: monospace;
  font-size: 10px;
}

.pmleavepg-inline-9 {
  font-weight: 600;
  font-size: 11px;
}

.pmleavepg-inline-10 {
  font-size: 9.5px;
  color: #94a3b8;
}

.pmleavepg-inline-11 {
  font-size: 10.5px;
}

.pmleavepg-inline-12 {
  font-size: 9px;
}

.pmleavepg-inline-13 {
  font-size: 10.5px;
  white-space: nowrap;
}

.pmleavepg-inline-14 {
  font-weight: 700;
  text-align: center;
}

.pmleavepg-inline-15 {
  font-size: 9px;
  color: #3b82f6;
}

.pmleavepg-inline-16 {
  font-size: 10.5px;
  max-width: 150px;
}

.pmleavepg-inline-17 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pmleavepg-inline-18 {
  font-size: 10.5px;
  max-width: 140px;
  color: #475569;
}

.pmleavepg-inline-19 {
  color: #cbd5e1;
}

.pmleavepg-inline-20 {
  display: flex;
  gap: 3px;
  flex-wrap: wrap;
  min-width: 120px;
}

.pmleavepg-inline-21 {
  font-size: 9px;
  padding: 3px 7px;
}

.pmleavepg-inline-22 {
  font-size: 9px;
  padding: 3px 7px;
}

.pmleavepg-inline-23 {
  font-size: 9px;
  padding: 3px 7px;
}

.pmleavepg-inline-24 {
  font-size: 9px;
  padding: 3px 7px;
  border-color: #c7d2fe;
  color: #4338ca;
}

.pmleavepg-inline-25 {
  font-size: 9.5px;
  color: #94a3b8;
  font-style: italic;
}

.pmleavepg-inline-26 {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 9px;
  padding: 16px;
  margin-bottom: 16px;
}

.pmleavepg-inline-27 {
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 4px;
}

.pmleavepg-inline-28 {
  font-size: 11px;
  color: #64748b;
  margin-bottom: 2px;
}

.pmleavepg-inline-29 {
  font-size: 11px;
  color: #64748b;
}

.pmleavepg-inline-30 {
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 9px;
  padding: 12px 16px;
  margin-bottom: 16px;
  font-size: 11px;
  color: #1e40af;
}

.pmleavepg-inline-31 {
  font-size: 10px;
  color: #94a3b8;
  margin-top: 2px;
}

.pmleavepg-inline-32 {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  margin-top: 20px;
}

.pmleavepg-dyn-2 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--pmleavepg-2-color);
}

.pmleavepg-dyn-3 {
  cursor: pointer;
  padding: 6px 14px;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/PM/PMLeavePg.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB","sourcesContent":[".pmleavepg-inline-1 {\n  text-align: center;\n  padding: 60px 20px;\n}\n\n.pmleavepg-inline-2 {\n  margin: 0 auto 20px;\n}\n\n.pmleavepg-inline-3 {\n  font-size: 14px;\n  color: #64748b;\n}\n\n.pmleavepg-inline-4 {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 16px;\n}\n\n.pmleavepg-inline-6 {\n  padding: 0;\n  overflow-x: auto;\n}\n\n.pmleavepg-inline-7 {\n  text-align: center;\n  padding: 40px;\n  color: #94a3b8;\n}\n\n.pmleavepg-inline-8 {\n  font-family: monospace;\n  font-size: 10px;\n}\n\n.pmleavepg-inline-9 {\n  font-weight: 600;\n  font-size: 11px;\n}\n\n.pmleavepg-inline-10 {\n  font-size: 9.5px;\n  color: #94a3b8;\n}\n\n.pmleavepg-inline-11 {\n  font-size: 10.5px;\n}\n\n.pmleavepg-inline-12 {\n  font-size: 9px;\n}\n\n.pmleavepg-inline-13 {\n  font-size: 10.5px;\n  white-space: nowrap;\n}\n\n.pmleavepg-inline-14 {\n  font-weight: 700;\n  text-align: center;\n}\n\n.pmleavepg-inline-15 {\n  font-size: 9px;\n  color: #3b82f6;\n}\n\n.pmleavepg-inline-16 {\n  font-size: 10.5px;\n  max-width: 150px;\n}\n\n.pmleavepg-inline-17 {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.pmleavepg-inline-18 {\n  font-size: 10.5px;\n  max-width: 140px;\n  color: #475569;\n}\n\n.pmleavepg-inline-19 {\n  color: #cbd5e1;\n}\n\n.pmleavepg-inline-20 {\n  display: flex;\n  gap: 3px;\n  flex-wrap: wrap;\n  min-width: 120px;\n}\n\n.pmleavepg-inline-21 {\n  font-size: 9px;\n  padding: 3px 7px;\n}\n\n.pmleavepg-inline-22 {\n  font-size: 9px;\n  padding: 3px 7px;\n}\n\n.pmleavepg-inline-23 {\n  font-size: 9px;\n  padding: 3px 7px;\n}\n\n.pmleavepg-inline-24 {\n  font-size: 9px;\n  padding: 3px 7px;\n  border-color: #c7d2fe;\n  color: #4338ca;\n}\n\n.pmleavepg-inline-25 {\n  font-size: 9.5px;\n  color: #94a3b8;\n  font-style: italic;\n}\n\n.pmleavepg-inline-26 {\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 9px;\n  padding: 16px;\n  margin-bottom: 16px;\n}\n\n.pmleavepg-inline-27 {\n  font-size: 13px;\n  font-weight: 600;\n  margin-bottom: 4px;\n}\n\n.pmleavepg-inline-28 {\n  font-size: 11px;\n  color: #64748b;\n  margin-bottom: 2px;\n}\n\n.pmleavepg-inline-29 {\n  font-size: 11px;\n  color: #64748b;\n}\n\n.pmleavepg-inline-30 {\n  background: #eff6ff;\n  border: 1px solid #bfdbfe;\n  border-radius: 9px;\n  padding: 12px 16px;\n  margin-bottom: 16px;\n  font-size: 11px;\n  color: #1e40af;\n}\n\n.pmleavepg-inline-31 {\n  font-size: 10px;\n  color: #94a3b8;\n  margin-top: 2px;\n}\n\n.pmleavepg-inline-32 {\n  display: flex;\n  gap: 8px;\n  justify-content: flex-end;\n  margin-top: 20px;\n}\n\n.pmleavepg-dyn-2 {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: var(--pmleavepg-2-color);\n}\n\n.pmleavepg-dyn-3 {\n  cursor: pointer;\n  padding: 6px 14px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
